import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import MedReasonPresForm from './MedReasonPresForm';

const EditMedReasonModal = ({ show, onHide, medreasonvalue, edittrigger, onCallParent }) => {
    const isEdit = Boolean(medreasonvalue && (medreasonvalue.reason_pres_id || medreasonvalue.reason_id || medreasonvalue.id));

    const handleSuccess = () => {
        if (onCallParent) onCallParent();
        if (onHide) onHide();
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title as="h5">
                    {isEdit ? 'Edit Reason Prescribed' : 'Add Reason Prescribed'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4">
                <MedReasonPresForm
                    edittrigger={edittrigger}
                    onCallParent={handleSuccess}
                    medreasonvalue={medreasonvalue}
                />
            </Modal.Body>
        </Modal>
    );
};

EditMedReasonModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    medreasonvalue: PropTypes.any,
    edittrigger: PropTypes.number,
    onCallParent: PropTypes.func
};

export default EditMedReasonModal;
